<template
  ><div class="common-wrapper" >
    <el-select id="commonSelect" v-model="value" popper-class="lhrselect" :clearable="canClearable" placeholder="请选择标签" @change="handleChange"
      ><div class="el-input" style="width:90%;margin-left:5%; " >
        <input
          type="text"
          placeholder="请输入"
          class="el-input__inner"
          v-model="dropDownValue"
          @keyup="dropDownSearch"
        />
      </div>
      <el-option v-for="item in selectData"  :key="item[dicProps.key]"
            :label="item[dicProps.label]"
            :value="item[dicProps.value]">
    </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
    props:{
      canClearable:{
        type:Boolean,
        default:false,
      },
        value:{
            type:String,
            default:''
        },
        dicProps:{
            default:{
                key: 'id',
                value: 'id',
                label:'title'
            }
        },
        dicData:{
            type:Array,
            default:[],
        }
    },
  data() {

    return {
      dropDownValue: '',
      optionsMetaAll: [],
        selectData:[]

    };
  },
  watch: {
    'dicData.length'(val){
        console.log("****",val)
        if(val>0){
            this.optionsMetaAll = [...this.dicData]
            this.selectData=[...this.dicData]
            console.log("----",this.optionsMetaAll)
        }
    },
  },
  created(){
  console.log("asd",this.dicData)
  console.log("this.optionsMetaAll",this.optionsMetaAll)
  console.log("this.selectData",this.selectData)
  if(this.dicData.length>0){
    this.optionsMetaAll = [...this.dicData]
            this.selectData=[...this.dicData]
  }
    setTimeout(() => {


    })
  },
  methods: {
    handleChange(value){
      console.log("-----handleChange-----")
        // this.$emit("update:value", value);
        this.$emit("input", value);
        this.$emit("change", value);
    },
    dropDownSearch() {
      var _this = this;
      if(this.dropDownValue==''){
        _this.selectData =[...this.dicData]
        console.log("----***",_this.dicData)
        }else{
            _this.selectData = _this.optionsMetaAll.filter(_this.filterSearch);
            console.log("dropDownSearch_selectData",_this.selectData ,)
        }

    },
    filterSearch(item) {
        console.log("item",item,)

      return item[this.dicProps.label].includes(this.dropDownValue);
    },
  },
};
</script>
<style  >
 .lhrselect .el-scrollbar {
  display: block !important;
}

</style>
